import { createAsyncThunk } from "@reduxjs/toolkit";
import reportApi from 'api/reportApi';
import { formatQueryParams } from "helpers/format";

export const reportAgencies = createAsyncThunk("Report Agencies", async (params: any = {}) => {
  try {
    const response = await reportApi.agencyReports(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});


export const reportInventories = createAsyncThunk("Report Inventories", async (params: any = {}) => {
  try {
    const response = await reportApi.inventoryReports(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});